<template name="GridRecord">
  <v-btn color="white" x-small class="grid-records">
    {{ $i18n.t("Showing") }}
    {{ table.from }} - {{ table.till }} of
    {{ table.records }}
  </v-btn>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "GridRecord",
  props: {
    grid: {
      default: {}
    }
  }
})
export default class GridRecord extends (Vue, Themeable) {
  get table() {
    const grid = this.grid;
    const page = grid.page ? grid.page : 0;
    const rows = grid.rows ? grid.rows.length : 0;
    const records = grid.records ? grid.records : 0;
    return {
      page: page,
      from: (grid.page - 1) * rows + 1,
      till: (grid.page - 1) * rows + rows,
      records: records
    };
  }
}
</script>

<style scoped>
.grid-records {
  float: right;
  text-transform: none;
  color: #555;
  top: 10px;
  right: 0px;
  font-size: 12px;
}
</style>
